import { styled } from '@mui/material';
import { Input } from '../Input';

export const StyledDatePicker = styled(Input)(() => ({}));
